import { createStore } from 'satcheljs';
import MailLayoutStore from './schema/MailLayoutStore';

const mailLayoutStore: MailLayoutStore = {
    showReadingPane: false,
    showListPane: true,
    showFolderPane: true,
    clientReadingPanePosition: null,
};

export let getStore = createStore<MailLayoutStore>('maillayout', mailLayoutStore);
